import { TranslateService } from '@ngx-translate/core';
import { ClinicalDocument, ClinicalDocumentData } from './clinical-document.model';

export class SickNote extends ClinicalDocument {
  public readonly type = 'sicknote';

  constructor(
    data: ClinicalDocumentData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
  }

  public get label() {
    return this.translateService.instant('sicknote_label', { doctor: this.doctor });
  }
}
